(function () {
    'use strict';

    angular.module('components.config', [
        'components.startup'
    ]);
})();